import UnderstandingEnvironments from "../../../../src/courses/partials/responsible-development/understanding-environments.mdx";
import * as React from 'react';
export default {
  UnderstandingEnvironments,
  React
};